import React from 'react'
import Interests from './Interests'
import Introduction from './Introduction'

const AboutMe = ({description}) => {
    return (
        <section className="pt-page pt-page-1" data-id="about_me">
            <Introduction description={description}/>
            <Interests/>
        </section>
    )
}

export default AboutMe